class CornerHeader {

  constructor(){
		this.trigger  = document.querySelector(`[data-trigger="corner-header"]`);
		this.target = document.querySelector(`[data-target="corner-header"]`);

		if(this.trigger && this.target){
			this._init();
		}
	}

	_init(){
		this.trigger.addEventListener('change', ()=> this.updateFieldActivation());
	}

	updateFieldActivation(){
		if(this.trigger.value !== ''){
			this.target.removeAttribute('disabled');
			this.target.value = '';
			for (var i = 0; i < this.target.options.length; i++) {
				if(this.target.options[i].getAttribute('data-domaine') !== 
						this.trigger.value && this.target.options[i].getAttribute('data-domaine') !== null){
							this.target.options[i].setAttribute('style', 'display: none;');
				}else{
					this.target.options[i].setAttribute('style', 'display: block;');
				}
			}
		}else{
			this.target.setAttribute('disabled', 'disabled');
		}
	}
}
  
export let cornerHeader = new CornerHeader();